// This function allow to reference chunks
__webpack_require__.k = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {2125: "RestaurantInfoStep",4951: "FullScreenMap",}[chunkId] + ".admin." + {2125: "bcc11f080df777ae",4951: "4f220bb8cd5ca44e",}[chunkId] + ".v2.css"
}